import { renderHtmlSection } from '@nx-paeonia/utils-http';
import { CartSections, getShopifyRootUrl } from '@nx-paeonia/utils-shopify';
import type { CartFlyoutComponent } from '../cart-flyout.component.js';

export async function refreshCartSection(): Promise<void> {
  const url = getShopifyRootUrl();
  const response = await fetch(`${url}?sections=cart-overlay`).then((r) => r.json());
  if (response?.['cart-overlay']) {
    renderCartSection(response);
  }
}

export function renderCartSection(sections: Record<CartSections, string>): void {
  if (sections[CartSections.cartOverlay]) {
    renderCartOverlay(sections[CartSections.cartOverlay]);
  }
}

function renderCartOverlay(sectionHTML: string): void {
  const cartOverlay = document.querySelector<CartFlyoutComponent>('y-cart-flyout');
  if (cartOverlay) {
    renderHtmlSection(cartOverlay, sectionHTML, { elementToPick: 'y-cart-flyout' });
  }
}
